import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=56d6d5c2&scoped=true&"
import script from "./ListPage.vue?vue&type=script&lang=js&"
export * from "./ListPage.vue?vue&type=script&lang=js&"
import style0 from "./ListPage.vue?vue&type=style&index=0&id=56d6d5c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6d5c2",
  null
  
)

export default component.exports